if (!customElements.get("cart-disclosure-modal")) {
  class CartDisclosureModal extends HTMLElement {
    constructor() {
      super();
      this.onOpenerClick = this.onOpenerClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onModalClick = this.onModalClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.removeIfOpenerDisconnected = this.removeIfOpenerDisconnected.bind(this);
    }
    connectedCallback() {
      var _a, _b, _c, _d;
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('[role="dialog"]');
      const controlsId = (_a = this.dialog) == null ? void 0 : _a.id;
      this.opener = ((_b = this.previousElementSibling) == null ? void 0 : _b.classList.contains("cart-item__disclosure")) ? this.previousElementSibling : controlsId ? document.querySelector(`[aria-controls="${controlsId}"]`) : null;
      this.closeButton = this.querySelector("[data-cart-disclosure-close]");
      let shouldRestoreOpen = false;
      document.querySelectorAll("cart-disclosure-modal").forEach((modal) => {
        if (modal === this || modal.id !== this.id) return;
        shouldRestoreOpen = shouldRestoreOpen || modal.hasAttribute("open");
        modal.remove();
      });
      (_c = this.opener) == null ? void 0 : _c.addEventListener("click", this.onOpenerClick);
      (_d = this.closeButton) == null ? void 0 : _d.addEventListener("click", this.onCloseClick);
      this.addEventListener("click", this.onModalClick);
      this.addEventListener("keyup", this.onKeyUp);
      if (this.parentElement !== document.body) {
        this.isMoving = true;
        document.body.appendChild(this);
        this.isMoving = false;
      }
      this.observeOpener();
      if (shouldRestoreOpen) this.show();
    }
    disconnectedCallback() {
      var _a, _b, _c;
      if (this.isMoving) return;
      (_a = this.openerObserver) == null ? void 0 : _a.disconnect();
      (_b = this.opener) == null ? void 0 : _b.removeEventListener("click", this.onOpenerClick);
      (_c = this.closeButton) == null ? void 0 : _c.removeEventListener("click", this.onCloseClick);
      this.removeEventListener("click", this.onModalClick);
      this.removeEventListener("keyup", this.onKeyUp);
      if (this.hasAttribute("open")) this.hide(false);
    }
    observeOpener() {
      var _a;
      (_a = this.openerObserver) == null ? void 0 : _a.disconnect();
      if (!this.opener) return;
      this.openerObserver = new MutationObserver(this.removeIfOpenerDisconnected);
      this.openerObserver.observe(document.body, { childList: true, subtree: true });
      this.removeIfOpenerDisconnected();
    }
    removeIfOpenerDisconnected() {
      var _a;
      if (this.isMoving || !this.isConnected || ((_a = this.opener) == null ? void 0 : _a.isConnected)) return;
      this.remove();
    }
    onOpenerClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.show();
    }
    onCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }
    onModalClick(event) {
      event.stopPropagation();
      if (event.target === this) this.hide();
    }
    onKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;
      event.preventDefault();
      event.stopPropagation();
      this.hide();
    }
    show() {
      var _a, _b;
      if (this.hasAttribute("open")) return;
      document.querySelectorAll("cart-disclosure-modal[open]").forEach((modal) => {
        if (modal !== this) modal.hide(false);
      });
      this.lockScroll();
      this.setAttribute("open", "");
      (_a = this.opener) == null ? void 0 : _a.setAttribute("aria-expanded", "true");
      if (typeof trapFocus === "function") {
        trapFocus(this, this.dialog);
      } else {
        (_b = this.dialog) == null ? void 0 : _b.focus();
      }
      window.pauseAllMedia();
    }
    hide(restoreFocus = true) {
      var _a;
      if (!this.hasAttribute("open")) return;
      this.removeAttribute("open");
      (_a = this.opener) == null ? void 0 : _a.setAttribute("aria-expanded", "false");
      this.unlockScroll();
      if (restoreFocus) {
        this.restoreFocusTrap();
      } else if (typeof removeTrapFocus === "function") {
        removeTrapFocus();
      }
      window.pauseAllMedia();
    }
    lockScroll() {
      this.bodyOverflowWasHidden = document.body.classList.contains("overflow-hidden");
      this.previousBodyPaddingRight = document.body.style.paddingRight;
      if (this.bodyOverflowWasHidden) return;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        const currentPaddingRight = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = `${currentPaddingRight + scrollbarWidth}px`;
      }
      document.body.classList.add("overflow-hidden");
    }
    unlockScroll() {
      if (this.bodyOverflowWasHidden) return;
      document.body.classList.remove("overflow-hidden");
      document.body.style.paddingRight = this.previousBodyPaddingRight;
    }
    restoreFocusTrap() {
      var _a, _b, _c, _d;
      const cartDrawer = (_a = this.opener) == null ? void 0 : _a.closest("cart-drawer.active");
      const cartNotification = (_c = (_b = this.opener) == null ? void 0 : _b.closest("cart-notification")) == null ? void 0 : _c.querySelector("#cart-notification.active");
      if (cartDrawer && typeof trapFocus === "function") {
        const containerToTrapFocusOn = cartDrawer.classList.contains("is-empty") ? cartDrawer.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
        if (containerToTrapFocusOn) {
          trapFocus(containerToTrapFocusOn, this.opener);
          return;
        }
      }
      if (cartNotification && typeof trapFocus === "function") {
        trapFocus(cartNotification, this.opener);
        return;
      }
      if (typeof removeTrapFocus === "function") {
        removeTrapFocus(this.opener);
      } else {
        (_d = this.opener) == null ? void 0 : _d.focus();
      }
    }
  }
  customElements.define("cart-disclosure-modal", CartDisclosureModal);
}
